<template>
	<svg
		:width="size"
		:height="size"
		viewBox="0 0 20 20"
		xmlns="http://www.w3.org/2000/svg"
		fill="none"
		role="img"
		:aria-hidden="ariaHidden"
	>
		<path
			d="M10 11.6668L13.3333 8.3335"
			:stroke="computedStroke"
			:stroke-width="strokeWidth"
			stroke-linecap="round"
			stroke-linejoin="round"
		/>
		<path
			d="M2.78354 15.8331C2.05205 14.5663 1.66693 13.1293 1.66687 11.6664C1.66681 10.2036 2.05183 8.76649 2.78322 7.49961C3.51461 6.23274 4.5666 5.18071 5.83344 4.44927C7.10029 3.71783 8.53736 3.33276 10.0002 3.33276C11.463 3.33276 12.9001 3.71783 14.167 4.44927C15.4338 5.18071 16.4858 6.23274 17.2172 7.49961C17.9486 8.76649 18.3336 10.2036 18.3335 11.6664C18.3335 13.1293 17.9484 14.5663 17.2169 15.8331"
			:stroke="computedStroke"
			:stroke-width="strokeWidth"
			stroke-linecap="round"
			stroke-linejoin="round"
		/>
	</svg>
</template>

<script>
export default {
	name: 'IconSpeedometer',
	props: {
		size: {
			type: [Number, String],
			default: 20
		},
		color: {
			type: String,
			default: 'currentColor'
		},
		filled: {
			type: Boolean,
			default: true
		},
		strokeWidth: {
			type: [Number, String],
			default: 1.65
		},
		ariaHidden: {
			type: Boolean,
			default: true
		}
	},
	computed: {
		computedFill() {
			return this.filled ? this.color : 'none'
		},
		computedStroke() {
			return this.color
		}
	}
}
</script>
